import { render, staticRenderFns } from "./AIAgent.vue?vue&type=template&id=24575716&"
import script from "./AIAgent.vue?vue&type=script&lang=js&"
export * from "./AIAgent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports